import * as React from "react";
import IconWrapper from "./IconWrapper";
import classNames = require("classnames");
import {IconVariant} from "./Icon";

interface IProps {
	/**
	 * Icon name.
	 */
	icon: string;
	/**
	 * Icon variant
	 */
	variant?: IconVariant;
	/**
	 * On Click handler
	 */
	onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Icon title (can be used as tooltip)
	 */
	iconTooltipText?: string;
	/**
	 * Custom CSS class name.
	 */
	customClass?: string;
}

export default class IconSmall extends React.Component<IProps, {}> {
	render() {
		const classFromProps = classNames({
			[`${this.props.customClass}`]: !!this.props.customClass
		});
		return (
			<span title={this.props.iconTooltipText} className={classFromProps}>
				<IconWrapper
					size={14}
					icon={this.props.icon}
					onClick={this.props.onClick}
					variant={this.props.variant}/>
			</span>
		);
	}
}
